import { CheckBoxReferenceTypeId } from 'app/area/codetable/item/screen-renderer/screen-pickers/constants';
import { CodeItem } from 'app/area/codetable/item/types-store';

export const isCheckBoxReferenceType = (codeItem: CodeItem) => !!codeItem && !!codeItem.category
  && codeItem.category.value === CheckBoxReferenceTypeId;
